"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGeneratedAPI = void 0;
const index_1 = require("../client/index");
const getGeneratedAPI = () => {
    const getLocations = (options) => {
        return (0, index_1.tpcBff)({ url: `/locations`, method: "GET" }, options);
    };
    return { getLocations };
};
exports.getGeneratedAPI = getGeneratedAPI;
//# sourceMappingURL=index.js.map